import { KillSwitchKey } from '../constants/kill-switch-key';
import { useKillSwitchQuery } from '../queries/useKillSwitchQuery';

export const useKillSwitchService = (key_name: KillSwitchKey) => {
  const { data, error, isLoading, isFetching, isError } = useKillSwitchQuery(key_name);

  return {
    loading: isLoading,
    fetching: isFetching,
    has_error: isError,
    is_enabled: data ?? false,
    error,
  };
};
